import React, { useEffect, useState } from "react";
import { StarFill, StarHalf, Star, ChevronUp, Trash } from "react-bootstrap-icons"; // Assuming you're using Bootstrap icons
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useNavigate } from "react-router-dom";
export default function Reviews({ rating, id, closeReviews }) {

  


  const [ratingExists, setRatingExists] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [complete, setComplete] = useState(false);
  const { user,dispatch } = useAuthContext();
  const [selectingRating,setSelectedRating] = useState(null)
const navi = useNavigate();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const rewviewExists = await axios.get(
        `${ApiConnectionString}/api/RatingExists/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setRatingExists(rewviewExists.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const renderStars = (stars) => {
    const fullStars = Math.floor(stars);
    const hasHalfStar = stars % 1 >= 0.5;

    return (
      <div className="d-flex align-items-center">
        {[...Array(5)].map((_, index) => {
          if (index < fullStars) {
            return <StarFill key={index} />;
          } else if (index === fullStars && hasHalfStar) {
            return <StarHalf key={index} />;
          } else {
            return <Star key={index} />;
          }
        })}
      </div>
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between  customNav rounded">
        <p className="m-2 fw-bold">Reviews</p>
        <ChevronUp size={20} className="m-2 pointer" onClick={closeReviews} />
      </div>
 
   
      <div className="scrollable-posts">
        {rating.length > 0 ? (
          rating.map((rev) => (
            <div key={rev.id} className="review-item mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="fw-bold">{rev.viewAppUser.username}</p>
                {renderStars(rev.stars)}
              </div>
              <p>{rev.content}</p>
        
            </div>
          ))
        ) : (
          <p>No reviews available.</p>
        )}
      </div>
    </div>
  );
}
